import classes from "../styles/RootLayout.module.css";
import { NavLink } from "react-router-dom";

export default function HeaderFooterNav() {
  return (
    /*<div className={classes.header}>*/
    <div>
      <NavLink
        to="/"
        className={({ isActive }) => (isActive ? classes.active : undefined)}
        end
      >
        Home
      </NavLink>
      <NavLink
        to="/AboutMe"
        className={({ isActive }) => (isActive ? classes.active : undefined)}
      >
        More About Me
      </NavLink>
      <NavLink
        to="/MyProjects"
        className={({ isActive }) => (isActive ? classes.active : undefined)}
      >
        My Web Lab
      </NavLink>
      <NavLink
        to="/MyArtWorks"
        className={({ isActive }) => (isActive ? classes.active : undefined)}
      >
        Visit the Artist in Me
      </NavLink>
      <NavLink
        to="/ContactMe"
        className={({ isActive }) => (isActive ? classes.active : undefined)}
      >
        Contact Me
      </NavLink>
    </div>
    /*</div>*/
  );
}
